<template>
  <!-- <div class="m-input" :class="validated ? 'warning' : isfocus ? 'active' : ''"> -->

  <div class="m-input" :class="isfocus ? 'active' : ''">
    <div class="icon">
      <i :class="'iconfont' + ' ' + icon"></i>
    </div>
    <input
      :type="currentType"
      refs="input"
      @focus="(isfocus = true), (focued = true)"
      @blur="isfocus = false"
      @input="handleInput"
      :placeholder="placeholder"
      :value="value"
      v-if="type != 'textarea'"
    />

    <textarea
      v-else
      :type="currentType"
      @focus="(isfocus = true), (focued = true)"
      @blur="isfocus = false"
      @input="handleInput"
      :placeholder="placeholder"
      :value="value"
    />
    <div class="showBtn" v-if="type === 'password'">
      <i
        :class="
          'iconfont' + ' ' + (showPassword ? 'icon-xianshi' : 'icon-yincang')
        "
        @click="showPassword = !showPassword"
      ></i>
    </div>
    <div class="DelBtn" v-if="del" title="删除内容">
      <i :class="'iconfont' + ' ' + 'icon-guanbi'" @click="removeValue"></i>
    </div>
  </div>
</template>

<script>
// 一个简单的输入框组件。。。确信
export default {
  name: "YKinput",
  props: {
    type: {
      type: String,
      default: "text",
    },
    icon: {
      type: String,
      default: "user",
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    del: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input_value: this.value,
      currentType: this.type !== "password" ? "text" : "password",
      showPassword: false,
      isfocus: false,
      // focued:false
    };
  },
  watch: {
    //   监听显示/隐藏密码
    showPassword: function (val) {
      this.currentType = val ? "text" : "password";
    },
  },
  // computed: {
  //   validated: function () {
  //     return this.focued && this.input_value == "";
  //   },
  // },
  methods: {
    handleInput(e) {
      let tempvalue = e.target.value;
      this.input_value =
        this.type === "Number" ? tempvalue.replace(/\D/g, "") : tempvalue;
      this.$emit("input", this.input_value);
    },
    removeValue() {
      this.input_value = "";
      this.$emit("input", this.input_value);
    },
  },
};
</script>

<style lang="less" scoped>
.m-input {
  margin: 1rem 0;
  position: relative;
  display: flex;
  width: 100%;
  padding: 1rem 1rem;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: solid 2px rgb(190, 187, 187);
  box-shadow: 10px 10px 100px #ffffff;
  input {
    flex: 1;
    margin-left: 1rem;
    display: inline-block;
    background: none;
    line-height: 1.5rem;
    font-size: 1.2rem;
    outline: none;
    border: none;
  }
  .showBtn {
    margin-left: 1rem;
  }
  .DelBtn {
    margin-left: 1rem;
    transition: none;
    &:hover {
      color: #000000;
      font-weight: 600;
    }
  }
}
.active {
  border: solid 2px rgb(97, 175, 239);
}
.warning {
  border: solid 2px rgb(250, 21, 21);
}
</style>
